/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PlayableMissionAvailability
 */
export interface PlayableMissionAvailability {
    /**
     * Global completion cap (null if unlimited)
     * @type {number}
     * @memberof PlayableMissionAvailability
     */
    maxCompletions?: number;
    /**
     * Count of total completions across all users
     * @type {number}
     * @memberof PlayableMissionAvailability
     */
    currentCompletions: number;
    /**
     * Global claim cap (null if unlimited)
     * @type {number}
     * @memberof PlayableMissionAvailability
     */
    maxClaims?: number;
    /**
     * Count of total claims across all users
     * @type {number}
     * @memberof PlayableMissionAvailability
     */
    currentClaims: number;
    /**
     * True when maxCompletions is set and currentCompletions >= maxCompletions
     * @type {boolean}
     * @memberof PlayableMissionAvailability
     */
    isCapped?: boolean;
}

/**
 * Check if a given object implements the PlayableMissionAvailability interface.
 */
export function instanceOfPlayableMissionAvailability(value: object): value is PlayableMissionAvailability {
    if (!('currentCompletions' in value) || value['currentCompletions'] === undefined) return false;
    if (!('currentClaims' in value) || value['currentClaims'] === undefined) return false;
    return true;
}

export function PlayableMissionAvailabilityFromJSON(json: any): PlayableMissionAvailability {
    return PlayableMissionAvailabilityFromJSONTyped(json, false);
}

export function PlayableMissionAvailabilityFromJSONTyped(json: any, ignoreDiscriminator: boolean): PlayableMissionAvailability {
    if (json == null) {
        return json;
    }
    return {
        
        'maxCompletions': json['maxCompletions'] == null ? undefined : json['maxCompletions'],
        'currentCompletions': json['currentCompletions'],
        'maxClaims': json['maxClaims'] == null ? undefined : json['maxClaims'],
        'currentClaims': json['currentClaims'],
        'isCapped': json['isCapped'] == null ? undefined : json['isCapped'],
    };
}

export function PlayableMissionAvailabilityToJSON(json: any): PlayableMissionAvailability {
    return PlayableMissionAvailabilityToJSONTyped(json, false);
}

export function PlayableMissionAvailabilityToJSONTyped(value?: PlayableMissionAvailability | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'maxCompletions': value['maxCompletions'],
        'currentCompletions': value['currentCompletions'],
        'maxClaims': value['maxClaims'],
        'currentClaims': value['currentClaims'],
        'isCapped': value['isCapped'],
    };
}

